import { render, staticRenderFns } from "./productHead.vue?vue&type=template&id=c8b6a038&scoped=true"
import script from "./productHead.vue?vue&type=script&lang=js"
export * from "./productHead.vue?vue&type=script&lang=js"
import style0 from "./productHead.vue?vue&type=style&index=0&id=c8b6a038&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6a038",
  null
  
)

export default component.exports